module.exports = __webpack_public_path__ + "static/img/product_1_8.6b774e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/product_1_8.png
// module id = BgPx
// module chunks = 34